import FingoMuiButton from '../../fingo/components/MuiButton';

const MuiButton = {
  ...FingoMuiButton,
  variants: [
    ...FingoMuiButton.variants,
    {
      props: { variant: 'secondary', color: 'primary' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.common.white,
        color: theme.palette.secondary.A500,
        border: `2px solid ${theme.palette.secondary.A300}`,
        boxShadow: 'none',
        borderRadius: 100,
        textTransform: 'uppercase',
        '& .MuiButton-startIcon svg path': {
          fill: theme.palette.secondary.A500,
        },
        '& .MuiButton-endIcon svg path': {
          fill: theme.palette.secondary.A500,
        },
        '&:hover': {
          backgroundColor: theme.palette.common.white,
          borderColor: theme.palette.secondary.A400,
        },
        '&:disabled': {
          backgroundColor: theme.palette.common.white,
          color: theme.palette.gray.A400,
          icon: {
            color: theme.palette.gray.A500,
          },
          '& .MuiButton-startIcon svg path': {
            fill: theme.palette.gray.A500,
          },
          '& .MuiButton-endIcon svg path': {
            fill: theme.palette.gray.A500,
          },
          borderColor: theme.palette.secondary.A200,
        },
      }),
    },
    {
      props: { variant: 'link' },
      style: ({ theme }) => ({
        color: theme.palette.secondary.A400,
        '&:hover': {
          backgroundColor: 'transparent',
          cursor: 'pointer',
          textDecoration: 'underline',
        },
      }),
    },
    {
      props: { variant: 'contained', color: 'primary' },
      style: ({ theme }) => ({
        borderRadius: 260,
        backgroundColor: theme.palette.secondary.A400,
        color: theme.palette.common.white,
        textTransform: 'uppercase',
        '&:hover': {
          backgroundColor: theme.palette.secondary.A500,
          boxShadow: '0 4px 12px 0 rgba(42, 52, 61, 0.10)',

        },
        '&:disabled': {
          backgroundColor: theme.palette.secondary.A300,
          color: theme.palette.common.white,
        },
      }),
    },
    {
      props: { variant: 'quickFilter' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.common.white,
        color: theme.palette.text.primary,
        boxShadow: 'none',
        border: `1px solid ${theme.palette.secondary.A400}`,
        '&:hover': {
          backgroundColor: theme.palette.secondary.A100,
        },
        '&.Mui-selected': {
          backgroundColor: theme.palette.secondary.A400,
          color: theme.palette.common.white,
          '&:hover': {
            backgroundColor: theme.palette.secondary.A500,
          },
          '& .MuiButton-startIcon svg path': {
            fill: theme.palette.common.white,
          },
        },
      }),
    },
    {
      props: { variant: 'onboardingOutlined' },
      style: ({ theme }) => ({
        mx: 'auto',
        height: '100%',
        py: 0,
        fontWeight: 700,
        color: theme.palette.text.primary,
        borderRadius: 8,
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: theme.palette.gray.A400,
        backgroundColor: theme.palette.common.white,
        '& .subtitle': {
          color: theme.palette.gray.A400,
        },
        '&:hover': {
          backgroundColor: theme.palette.secondary.A100,
        },
        '&.Mui-selected': {
          borderColor: 'transparent',
          color: theme.palette.common.white,
          backgroundColor: theme.palette.secondary.A400,
          '& .subtitle': {
            color: theme.palette.common.white,
          },
          '&:hover': {
            backgroundColor: theme.palette.secondary.A400,
          },
        },
      }),
    },
    {
      props: { size: 'rounded' },
      style: () => ({
        borderRadius: 100,
      }),
    },
    {
      props: { variant: 'navbarButton' },
      style: ({ theme }) => ({
        '& .MuiTypography-root': {
          color: 'white',
          fontSize: theme.typography.small_3.fontSize,
        },
      }),
    },
  ],
};

export default MuiButton;
